<template>
  <div class="wizard-body columns content-box small-9">
    <banner
      v-if="hasError"
      color-scheme="alert"
      :banner-message="errorMessage"
    />
    <div class="login-init full-height text-center">
      <form @submit.prevent="requestAuthorization">
        <woot-submit-button
          icon="brand-instagram"
          :button-text="$t('INBOX_MGMT.ADD.INSTAGRAM.CONTINUE_WITH_INSTAGRAM')"
          type="submit"
          :loading="isRequestingAuthorization"
        />
      </form>
      <p>{{ $t('INBOX_MGMT.ADD.INSTAGRAM.HELP') }}</p>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import instagramClient from '../../../../../api/channel/instagramClient';
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  components: { Banner },
  mixins: [alertMixin],
  data() {
    return {
      isRequestingAuthorization: false,
      hasError: false,
      errorMessage: '',
    };
  },
  mounted() {
    this.checkForErrorInQuery();
  },
  methods: {
    checkForErrorInQuery() {
      const { error_message: errorMessage } = this.$route.query;
      if (errorMessage) {
        this.hasError = true;
        this.errorMessage = errorMessage;
        this.$router.replace(this.$route.path);
      }
    },
    async requestAuthorization() {
      try {
        this.isRequestingAuthorization = true;
        const {
          data: { url },
        } = await instagramClient.generateAuthorization();
        window.location.href = url;
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.INSTAGRAM.ERROR_MESSAGE'));
      } finally {
        this.isRequestingAuthorization = false;
      }
    },
  },
};
</script>
